import { identity, omit } from 'lodash';
import React from 'react';
import { filterToValidAttributes } from '@zocdoc/dom-property';

export default ({ children, ...props }) => {
    const transferrableProps = filterToValidAttributes(omit(props, 'title'));
    return (
        <div {...transferrableProps}>
            {React.Children.map(children, identity)}
        </div>
    );
};
